export default __webpack_public_path__ + "static/media/revievs2.14b710cd.jpg";